export enum PrinterOptionsEnum {
  Printticket = 0,
  PrintNoPrice = 1,
  PrintPartial = 2,
  PrintPartialNoPrice = 3,
  PrintEpured = 4,
  PrintPartialEpured = 5,
}
